import { startAuthentication, browserSupportsWebAuthn, browserSupportsWebAuthnAutofill, WebAuthnAbortService } from '@simplewebauthn/browser';
import { httpsCallable } from 'firebase/functions';
import { signInWithCustomToken, signOut } from 'firebase/auth';
import { projectAuth, projectFunctions } from '@/firebase/firebase';
const begin = httpsCallable(projectFunctions, 'beginAdminPasskeySignIn');
const finish = httpsCallable(projectFunctions, 'finishAdminPasskeySignIn');
const manage = httpsCallable(projectFunctions, 'manageAdminSession');
export const passkeysSupported = () => window.location.origin === 'https://admin.lomaxlawconnect.com' && browserSupportsWebAuthn();
export const passkeyAutofillSupported = browserSupportsWebAuthnAutofill;
export const cancelPasskey = () => WebAuthnAbortService.cancelCeremony();
export async function signInWithAdminPasskey(autofill, stillActive, onAssertion) {
  const { data } = await begin();
  if (!stillActive()) return;
  const response = await startAuthentication({ optionsJSON: data.options, useBrowserAutofill: autofill });
  if (!stillActive()) return;
  onAssertion();
  const { data: verified } = await finish({ challengeId: data.challengeId, response });
  if (!stillActive()) return;
  const credential = await signInWithCustomToken(projectAuth, verified.token);
  try {
    if (!stillActive()) throw new Error('Sign-in canceled');
    const session = await manage({ action: 'start' });
    if (session.data.mfaRequired || !session.data.deadline) throw new Error('Session unavailable');
    if (!stillActive()) throw new Error('Sign-in canceled');
    return credential.user.uid;
  } catch (error) {
    try { await manage({ action: 'end' }); } catch { /* Local sign-out remains available offline. */ }
    await signOut(projectAuth);
    throw error;
  }
}
